module.exports = __webpack_public_path__ + "static/media/turnkey_large_banner.e0976847.jpg";